import styles from "./VideoSearchResult.module.css";
import React from "react";

export function Highlight({highlights}: {highlights: string[]}) {
    return (
        <span
            className={styles.highlight}
            dangerouslySetInnerHTML={{__html: highlights[0]}}
        />
    );
}
